const handleStaffColor = ({ role }) => {
  switch (role.toLocaleUpperCase()) {
    case 'TEMPORARY':
      return 0;
    case 'WARDIC':
      return 1;
    case 'NURSE':
      return 2;
    case 'CLERK':
      return 3;
    case 'SUPPORTINGSTAFF':
      return 4;
    default:
      break;
  }
};

export default handleStaffColor;
